import { css, html, LitElement } from 'lit-element';

export class UcFooterAppMobile extends LitElement {
  static get styles() {
    return css`
      :host {
        position: relative;

        width: 100%;
        height: 0;
        padding-top: 24%;
        color: transparent;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;

        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      :host([android]) {
        background-image: url('https://cdn.leroymerlin.ru/lmru/image/upload/v1/other/navigation-microfronts/header-footer/google.svg/file.svg');
      }

      :host([ios]) {
        background-image: url('https://cdn.leroymerlin.ru/lmru/image/upload/v1/other/navigation-microfronts/header-footer/appstore.svg/file.svg');
      }

      ::slotted(*:not(a)) {
        display: none;
      }

      ::slotted(a) {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;

        display: block;

        color: transparent;

        font-size: 0;

        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }
    `;
  }

  render() {
    return html` <slot></slot> `;
  }
}
